import { useMutation } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useAcceptInvitationMutation = () => {
  const { projects } = useAvApi();

  return useMutation({
    mutationKey: ['projects', 'postV2ProjectsUsersInvitationsAccept'],
    mutationFn: async (token: string) => {
      const { data } = await projects.postV2ProjectsUsersInvitationsAccept(
        null,
        {
          token,
        }
      );

      return data;
    },
  });
};
